import cuid2 from '@paralleldrive/cuid2';
import { getLocalStorage, nullableDate  } from '@trinity/chat-components';
import { getAuthProvider } from './auth-provider';
import { getClient } from './client-http';
import * as $session from './session';

export interface TrinityEdgeCallbackParams {
  sessionId: string;
  fingerprint: string;
}

export interface TrinityEdgeCallbackResponse {
  authenticated: boolean;
  expiry: Date | null;
  userId: number | null;
  returnUrl: string | null;
  endSessionUrl: string | null;
}

export function callback(data: TrinityEdgeCallbackParams): Promise<{ type: 'redirect'; returnUrl: string }> {
  return getClient().post<TrinityEdgeCallbackResponse & { expiry: string }>(`/auth/trinity-edge-callback`, data)
    .then(async ({ data: response }) => {
      clearTrinityEdgeFingerprint();
      await getAuthProvider().authenticate({
        authSource: 'cookie',
        sessionMeta: {
          authenticated: response.authenticated,
          expiry: nullableDate(response.expiry),
        },
      });

      $session.setLastLoginStrategy({
        strategy: 'enterprise',
        identifier: 'trinity-edge',
        endSessionUrl: response.endSessionUrl || '',
      });

      return Promise.resolve({
        type: 'redirect',
        returnUrl: response.returnUrl || '/',
      });
    });
}

export const LocalStorageKeys = Object.freeze({
  TrinityEdgeFingerprint: 'msl-copilot:trinity-edge-fingerprint',
});

export function getOrCreateTrinityEdgeFingerprint() {
  const $storage = getLocalStorage();
  try {
    const value = $storage.getItem(LocalStorageKeys.TrinityEdgeFingerprint);
    if (value) return value;
    const fingerprint = cuid2.createId();
    $storage.setItem(LocalStorageKeys.TrinityEdgeFingerprint, fingerprint);
    return fingerprint;
  } catch {
    const fingerprint = cuid2.createId();
    $storage.setItem(LocalStorageKeys.TrinityEdgeFingerprint, fingerprint);
    return fingerprint;
  }
}

export function clearTrinityEdgeFingerprint() {
  getLocalStorage().removeItem(LocalStorageKeys.TrinityEdgeFingerprint);
}